import { Workout } from '@kinomap-dev/ng-ui-lib/core';

export function convertWorkoutToWorkoutContentTableItem(workout: Workout): any {
  return {
    id: workout.id,
    title: { name: workout.name, thumbnail: workout.thumbnails },
    sport: workout.sport,
    mode: workout.mode,
    duration: workout.duration,
    level: workout.difficulty_level,
    sessions: 9999999,
    comments: workout.comments_count,
    likes: workout.likes_count,
    labels: ['test', 'my test label', 'is mock'],
  };
}
